<template>
  <div
    :class="[showBadge ? 'list-item list-badge' : 'list-item']"
    :data-action="dataAction"
    :data-listname="dataListname"
    :data-stockname="dataStockname"
    :data-fundname="dataFundname"
    @click="action(query)"
  >
    <div v-if="index" class="index vertical-center">{{ index }}</div>
    <div v-if="showBadge" class="small-left vertical-center">
      <div class="badge">{{query.type}}</div>
    </div>
    <div class="left vertical-center" :class="goldStyle">
      <h3>{{ name }}</h3>
      <p>
        <i class="far fa-clock"></i>
        {{ date | calendar }}
      </p>
    </div>
    <div class="middle vertical-center" :class="goldStyle">
      <h4 :class="color">{{ change | percent }}</h4>
      <p>{{ period }}</p>
    </div>
    <div class="right vertical-center" :class="goldStyle">
      <div class="row">
        <h4>{{ price | currency(dataAction) }} ฿</h4>
        <i class="fas fa-chevron-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"

export default {
  name: "list-item",
  props: {
    name: {
      type: String,
      default: "loading"
    },
    dataFundname: {
      type: String,
      default: null
    },
    dataStockname: {
      type: String,
      default: null
    },
    dataListname: {
      type: String,
      default: null
    },
    dataAction: {
      type: String,
      default: null
    },
    date: {
      type: String,
      default: null
    },
    change: {
      type: [Number, String],
      default: null
    },
    period: {
      type: String,
      default: ""
    },
    price: {
      type: [Number, String],
      default: null
    },
    action: {
      type: Function
    },
    query: {
      type: Object
    },
    index: {
      type: Number
    },
    showBadge: {
      type: Boolean,
      default: false
    },
    goldStyle: {
      type: String,
      default: ""
    }
  },
  computed: {
    color: function() {
      if (this.change > 0) {
        return { green: true }
      } else if (this.change < 0) {
        return { red: true }
      }

      return { normal: true }
    }
  },
  methods: {},
  filters: {
    calendar(timestamp) {
      if (timestamp) {
        return moment(timestamp).format("DD/MM/YY")
      }
      return ""
    },
    currency: function(val,arg1) {
      let toNumber = parseFloat(val)
      if (arg1 == "open_fund") {
        return toNumber
        .toLocaleString("th", {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4
        })
      } else {
        return toNumber
        .toLocaleString("th", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
    },
    percent: function(val) {
      if (val > 0) {
        return "+" + parseFloat(val).toFixed(2) + " %"
      }

      return parseFloat(val).toFixed(2) + " %"
    }
  }
}
</script>

<style lang='scss' scoped>
.list-item {
  display: flex;
  justify-content: space-between;
  color: $color-normal-text;
  height: 67px;
  position: relative;
  padding-left: 16px;
  pointer-events: auto;

  .badge {
    @extend %font-size-ss;
    text-transform: uppercase;
    transform: rotate(-90deg);
    color: #d1d1d1;
    font-weight: bold;
    pointer-events: none;
    text-align: center;
    width: 64px;
    position: absolute;
    left: -16px;
  }

  .index {
    color: $color-secondary;
    @extend %font-size-m;
    pointer-events: none;
    margin-right: 14px;
    font-weight: bold;
  }

  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(186, 186, 186, 0.24), 0 0 6px 0 rgba(228, 232, 234, 0);
  background-color: $base-white;

  .vertical-center {
    pointer-events: none;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .small-left {
    pointer-events: none;
    background-color: #f9f9f9;
    width: 10%;
    margin-right: 16px;
  }
  .left {
    pointer-events: none;
    width: 32%;
    p {
      @extend %font-size-ss;
      color: $color-secondary-text;
    }
  }

  .middle {
    pointer-events: none;
    width: 20%;
    text-align: center;
    p {
      color: $color-secondary-text;
    }
  }

  .gold-style {
    pointer-events: none;
    h3 {
      @extend %font-size-ss;
    }
    h4 {
      @extend %font-size-ss;
    }
  }

  .right {
    pointer-events: none;
    width: 38%;
    display: flex;
    text-align: right;

    .row {
      h4 {
        font-weight: normal;
        display: inline-block;
      }
      i {
        font-weight: normal;
        display: inline-block;
        // iphone 5
        @media screen and (device-aspect-ratio: 40/71) {
          margin-left: 10px;
          margin-right: 10px;
        }
        margin-left: 18px;
        margin-right: 16px;
        color: $color-light-grey-2;
        font-size: 12px;
      }
    }
  }
}

h3 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @extend %font-size-s;
  margin: 0px;
}

h4 {
  margin: 0px;
  @extend %font-size-s;
}

p {
  margin: 0px;
  @extend %font-size-ss;
}

.green {
  color: $color-plus;
}

.red {
  color: $color-minus;
}

.list-item:last-child {
  border-bottom: none;
}

.list-badge {
  padding-left: 0px !important;
  margin: 16px 0;
}
</style>
